module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-E-patch-shadow.f57d09b5.png";